/* =============================================================
   Supabase client — single instance, configured from env.

   The anon (publishable) key is safe to embed in the bundle: it
   only grants access through Row-Level-Security policies in
   Postgres. Security is enforced by the DB, not by key secrecy.

   The service_role key is NEVER used here and never enters the
   frontend code; it lives only in server-side jobs (none for now).
   ============================================================ */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // We log rather than throw so the public landing still renders;
  // anything that touches Supabase will fail later with a clear msg.
  console.warn(
    '[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing. ' +
      'Copy .env.example to .env.local and fill them in.',
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  url ?? 'http://invalid.local',
  anonKey ?? 'invalid',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Implicit flow (the SDK default). Email-confirmation links use
      // token_hash and are device-portable: staff can sign up on a laptop
      // and click the confirmation email on their phone. With 'pkce' set
      // here, links would only work in the originating browser session.
      flowType: 'implicit',
    },
  },
);
